import Typography from '@mui/material/Typography';
import {useTheme} from '@mui/material/styles';
import {BiInfoCircle} from 'react-icons/bi';

import Alert from '@jobseeker/lotus/components/Alert';
import {VersionVariants} from '@jobseeker/lotus/enums';

import type {ReactNode} from 'react';

type JdNoticeBannerProps = {
  children: ReactNode;
  'data-component'?: string;
  'data-testid'?: string;
};

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

// Shared shell for the notices that hang off the bottom of the job-detail card
// (ATS redirect note, stale-job notice): a white banner with an info icon and a
// primary-coloured left accent, squared off on top so it reads as part of the
// card above it.
const JdNoticeBanner = ({children, ...rest}: JdNoticeBannerProps) => {
  const theme = useTheme();
  const accentColor = theme.palette.primary.main;

  return (
    <Alert
      variant={VersionVariants.VERSION_TWO}
      show={true}
      background="#fff"
      icon={
        <Typography color={accentColor} lineHeight={0} fontSize={{xxs: 20}}>
          <BiInfoCircle />
        </Typography>
      }
      sx={{
        mt: isAppIimjobs ? 0 : {xxs: -1, md: 0},
        borderTop: '1px solid #E7EBF0',
        borderLeft: `4px solid ${accentColor}`,
        borderRadius: '0px',
        borderBottomLeftRadius: '10px !important',
        borderBottomRightRadius: '10px',
      }}
      {...rest}
    >
      <Typography fontSize={15} color="text.primary" lineHeight="20px">
        {children}
      </Typography>
    </Alert>
  );
};

export default JdNoticeBanner;
